import { render, staticRenderFns } from "./AddPrebuiltSurveys.vue?vue&type=template&id=5cc45564&"
import script from "./AddPrebuiltSurveys.vue?vue&type=script&lang=ts&"
export * from "./AddPrebuiltSurveys.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports